(function () {
  // Create overlay once
  let overlay = document.querySelector('.ambi-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'ambi-overlay';
    document.body.appendChild(overlay);
  }

  // Track all wrappers
  const wrappers = document.querySelectorAll('.ambi-variant-popup-wrapper');

  // Skip if already initialized
  wrappers.forEach((wrapper) => {
    if (wrapper.dataset.ambiInit === 'true') return;
    wrapper.dataset.ambiInit = 'true';

    const popupBtn = wrapper.querySelector('.ambi-popup-variant');
    const variantsPanel = wrapper.querySelector('.ambi-other-variants');
    if (!popupBtn || !variantsPanel) return;

    const originalParent = variantsPanel.parentElement;
    wrapper._popupBtn = popupBtn;
    wrapper._variantsPanel = variantsPanel;
    wrapper._originalParent = originalParent;
    wrapper._isTeleported = false;

    // Toggle popup on click
    popupBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isMobile = window.innerWidth <= 768;
      const isOpening = !variantsPanel.classList.contains('show');

      if (isMobile && isOpening) {
        document.body.classList.add('ambi-no-scroll');
        overlay.classList.add('show');
      } else if (isMobile) {
        document.body.classList.remove('ambi-no-scroll');
        overlay.classList.remove('show');
      }

      variantsPanel.classList.toggle('show');
      popupBtn.classList.toggle('hide', isOpening);
    });
  });

  // ✅ One global outside click handler
  document.addEventListener('click', (event) => {
    wrappers.forEach((wrapper) => {
      const panel = wrapper._variantsPanel;
      const btn = wrapper._popupBtn;

      if (
        panel.classList.contains('show') &&
        !wrapper.contains(event.target) &&
        !panel.contains(event.target) &&
        !overlay.contains(event.target)
      ) {
        panel.classList.remove('show');
        btn.classList.remove('hide');
        document.body.classList.remove('ambi-no-scroll');
        overlay.classList.remove('show');
      }
    });
  });

  // ✅ One global overlay click
  overlay.addEventListener('click', () => {
    wrappers.forEach((wrapper) => {
      wrapper._variantsPanel.classList.remove('show');
      wrapper._popupBtn.classList.remove('hide');
    });
    document.body.classList.remove('ambi-no-scroll');
    overlay.classList.remove('show');
  });

  // ✅ One global resize handler
  const teleportIfMobile = () => {
    wrappers.forEach((wrapper) => {
      const panel = wrapper._variantsPanel;
      const isMobile = window.innerWidth <= 768;

      if (isMobile && !wrapper._isTeleported) {
        document.body.appendChild(panel);
        panel.classList.add('mobile-floating');
        wrapper._isTeleported = true;
      } else if (!isMobile && wrapper._isTeleported) {
        wrapper._originalParent.appendChild(panel);
        panel.classList.remove('mobile-floating');
        wrapper._isTeleported = false;
      }
    });
  };

  window.addEventListener('resize', teleportIfMobile);
  teleportIfMobile();
})();
